import axiosInstance from './axiosInstance';

export interface CategoryArticleRow {
  id: string;
  categoryName: string;
  title: string;
  content: string;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export class CategoryArticleApi {
  static async getByCategoryName(categoryName: string): Promise<CategoryArticleRow | null> {
    const response = await axiosInstance.get(`/cms/v1/category/${encodeURIComponent(categoryName)}/article`);
    return response.data.data.article;
  }

  static async saveByCategoryName(categoryName: string, payload: { title: string; content: string; articleId?: string }): Promise<CategoryArticleRow> {
    const response = await axiosInstance.post(`/cms/v1/category/${encodeURIComponent(categoryName)}/article`, payload);
    return response.data.data.article;
  }

  static async list(skip = 0, limit = 20, query?: { categoryName?: string; title?: string }): Promise<{ list: CategoryArticleRow[]; total: number }> {
    const response = await axiosInstance.get('/cms/v1/category-article', {
      params: {
        skip,
        limit,
        categoryName: query?.categoryName || undefined,
        title: query?.title || undefined,
      },
    });
    return response.data.data;
  }

  static async update(id: string, payload: Partial<Pick<CategoryArticleRow, 'title' | 'content'>>): Promise<CategoryArticleRow> {
    const response = await axiosInstance.put(`/cms/v1/category-article/${id}`, payload);
    return response.data.data.article;
  }

  static async remove(id: string): Promise<void> {
    await axiosInstance.delete(`/cms/v1/category-article/${id}`);
  }
}
